import { useQuery } from "@tanstack/react-query"

import { FINANCE_OPERATION_TYPE_QUERY_KEY } from "@/constants/query"

const MOCK_DATA = [
  {
    id: 0,
    name: "Заказ в работе"
  },
  {
    id: 3,
    name: "Счет"
  },
  {
    id: 4,
    name: "Заказ отменён"
  }
]

export const useFinanceOperationTypeQuery = () => {
  return useQuery({
    queryFn: () => MOCK_DATA,
    queryKey: [FINANCE_OPERATION_TYPE_QUERY_KEY]
  })
}